module.exports = __webpack_public_path__ + "img/T7A6679.8168dbca.jpg";